module.exports = __webpack_public_path__ + "static/media/tramonto.020b1244.jpeg";